module.exports = __webpack_public_path__ + "images/referenzen/werbespot/tesa_malerband_perfect_tvc27_small.jpg";